// 轻量文案表：zh 为默认；缺 key 时回落中文
const zh = {
  // menu
  'menu.dashboard': '概览',
  'menu.modelsquare': '模型广场',
  'menu.playground': '模型体验',
  'menu.token': 'API Key',
  'menu.billing': '账单与用量',
  'menu.team': '我的团队',
  'menu.profile': '我的',
  'menu.product-pricing': '价格与成本',
  'menu.supply': '供给与路由',
  'menu.customer': '客户',
  'menu.customer-pricing': '客户定价',
  'menu.user-spend': '用户消费',
  'menu.log': '用量与纪录',
  'menu.upstream-recon': '上游对账',
  'menu.offlinetopup': '线下充值',
  'menu.setting': '设定',

  // common / profile
  'common.all': '全部',
  'profile.center': '个人中心',
  'profile.logout': '退出登录',
  'profile.account': '账号',

  // greetings
  'greet.dawn': '凌晨好',
  'greet.morning': '上午好',
  'greet.noon': '中午好',
  'greet.afternoon': '下午好',
  'greet.evening': '晚上好',
  'role.admin': '管理员',
  'role.viewer': '只读同事',

  // dashboard
  'dash.channelMgmt': '渠道管理',
  'dash.customerMgmt': '客户管理',
  'dash.platformSpend': '平台消费额',
  'dash.range7d': '近7日',
  'dash.range30d': '近30日',
  'dash.rangeCustom': '自定义时段',
  'dash.trend7d': '近 7 日平台消费趋势',
  'dash.trend30d': '近 30 日平台消费趋势',
  'dash.trendCustom': '自定义时段平台消费趋势',
  'dash.todayByModel': '今日按模型消费',

  // model square
  'ms.title': '模型广场',
  'ms.subtitle': '接入 {n} 款模型 · 一个 API Key 全部调用 · 展示价与扣费同源',
  'ms.searchPh': '搜索模型名 / 模型 ID',
  'ms.provider': '厂商',
  'ms.allProviders': '全部厂商',
  'ms.source': '来源',
  'ms.official': '官方',
  'ms.pool': '号池',
  'ms.sort': '排序',
  'ms.sortRecommend': '推荐',
  'ms.sortPriceAsc': '价格 低 → 高',
  'ms.sortPriceDesc': '价格 高 → 低',
  'ms.sortCtxDesc': '上下文 大 → 小',
  'ms.typeAll': '全部',
  'ms.typeText': '文本',
  'ms.typeCoding': 'Coding',
  'ms.kind': '模型类别',
  'ms.allKinds': '全部类别',
  'ms.kind.chat': '对话',
  'ms.kind.coding': 'Coding',
  'ms.kind.reasoning': '推理',
  'ms.kind.embedding': 'Embedding',
  'ms.kind.rerank': 'Rerank',
  'ms.kind.image_gen': '文生图',
  'ms.kind.image_edit': '图像编辑',
  'ms.kind.video_gen': '文生视频',
  'ms.kind.tts': '语音合成',
  'ms.kind.asr': '语音识别',
  'ms.modText': '文本模型',
  'ms.modTextSub': '对话 · Coding · 推理',
  'ms.modImage': '图片模型',
  'ms.modImageSub': '文生图 · 图像编辑',
  'ms.modVideo': '视频模型',
  'ms.modVideoSub': '文生视频 · 按秒计费',
  'ms.modAudio': '语音模型',
  'ms.modAudioSub': '语音合成 · 语音识别',
  'ms.available': '可用',
  'ms.context': '上下文',
  'ms.maxOutput': '最大输出',
  'ms.input': '输入',
  'ms.output': '输出',
  'ms.webSearch': '网页搜索',
  'ms.loading': '加载模型中…',
  'ms.loadingHint': '报价与扣费同源加载中，暂不展示本地价',
  'ms.priceUnavailable': '报价暂不可用',
  'ms.priceUnavailableHint': '为防止计费与成本误导，未回落本地目录价。请稍后刷新，或检查商品与价格 SSOT。',
  'ms.empty': '没有符合条件的模型',
  'ms.emptyHint': '试试减少筛选条件,或换个关键词',
  'ms.resetFilters': '清除筛选',
  'ms.viewAll': '查看全部 {n} 款官方模型 ▾',
  'ms.collapse': '收起 ▴',
  'ms.allOfficial': '全部{title}',
  'ms.legacy': '📦 经典旧版 · {n} 款（老而能用，{action}）',
  'ms.legacyOpen': '点开查看 ▾',
  'ms.legacyClose': '收起 ▴',
  'ms.cap.vision': '视觉',
  'ms.cap.functions': '函数',
  'ms.cap.reasoning': '推理',
  'ms.cap.caching': '缓存',
  'ms.cap.web': '搜索',
  'ms.cap.audio': '音频',
  'ms.cap.video': '视频',
  'ms.cap.pdf': 'PDF',
  'ms.cap.chat': '对话',
  'ms.copyId': '点击复制模型 ID',
  'ms.openaiCompat': 'OpenAI 兼容',
  'ms.anthropicNative': 'Anthropic 原生',
  'ms.savePct': '省 {n}%',
  'ms.cacheRead': '缓存读取',
  'ms.cacheWrite': '缓存写入',
  'ms.genImage': '图片生成',
  'ms.genVideo': '视频生成',
  'ms.genAudio': '语音',
  'ms.unitImage': '张',
  'ms.unitAudio': '万字符',
  'ms.unitVideo': '秒'
};

const en = {
  'menu.dashboard': 'Overview',
  'menu.modelsquare': 'Model Square',
  'menu.playground': 'Playground',
  'menu.token': 'API Key',
  'menu.billing': 'Billing & Usage',
  'menu.team': 'My Team',
  'menu.profile': 'Profile',
  'menu.product-pricing': 'Pricing & Cost',
  'menu.supply': 'Supply & Routing',
  'menu.customer': 'Customers',
  'menu.customer-pricing': 'Customer Pricing',
  'menu.user-spend': 'User Spend',
  'menu.log': 'Usage & Logs',
  'menu.upstream-recon': 'Upstream Recon',
  'menu.offlinetopup': 'Offline Top-up',
  'menu.setting': 'Settings',

  'common.all': 'All',
  'profile.center': 'Profile',
  'profile.logout': 'Log out',
  'profile.account': 'Account',

  'greet.dawn': 'Good night',
  'greet.morning': 'Good morning',
  'greet.noon': 'Good afternoon',
  'greet.afternoon': 'Good afternoon',
  'greet.evening': 'Good evening',
  'role.admin': 'Admin',
  'role.viewer': 'View only',

  'dash.channelMgmt': 'Channels',
  'dash.customerMgmt': 'Customers',
  'dash.platformSpend': 'Platform spend',
  'dash.range7d': 'Last 7 days',
  'dash.range30d': 'Last 30 days',
  'dash.rangeCustom': 'Custom range',
  'dash.trend7d': 'Platform spend · last 7 days',
  'dash.trend30d': 'Platform spend · last 30 days',
  'dash.trendCustom': 'Platform spend · custom range',
  'dash.todayByModel': 'Today by model',

  'ms.title': 'Model Square',
  'ms.subtitle': '{n} models · one API Key for all · list price matches billing',
  'ms.searchPh': 'Search model name / ID',
  'ms.provider': 'Provider',
  'ms.allProviders': 'All providers',
  'ms.source': 'Source',
  'ms.official': 'Official',
  'ms.pool': 'Pool',
  'ms.sort': 'Sort',
  'ms.sortRecommend': 'Recommended',
  'ms.sortPriceAsc': 'Price: low → high',
  'ms.sortPriceDesc': 'Price: high → low',
  'ms.sortCtxDesc': 'Context: large → small',
  'ms.typeAll': 'All',
  'ms.typeText': 'Text',
  'ms.typeCoding': 'Coding',
  'ms.kind': 'Category',
  'ms.allKinds': 'All categories',
  'ms.kind.chat': 'Chat',
  'ms.kind.coding': 'Coding',
  'ms.kind.reasoning': 'Reasoning',
  'ms.kind.embedding': 'Embedding',
  'ms.kind.rerank': 'Rerank',
  'ms.kind.image_gen': 'Image gen',
  'ms.kind.image_edit': 'Image edit',
  'ms.kind.video_gen': 'Video gen',
  'ms.kind.tts': 'TTS',
  'ms.kind.asr': 'Speech to text',
  'ms.modText': 'Text models',
  'ms.modTextSub': 'Chat · Coding · Reasoning',
  'ms.modImage': 'Image models',
  'ms.modImageSub': 'Text-to-image · Edit',
  'ms.modVideo': 'Video models',
  'ms.modVideoSub': 'Text-to-video · per second',
  'ms.modAudio': 'Audio models',
  'ms.modAudioSub': 'TTS · Speech recognition',
  'ms.available': 'Available',
  'ms.context': 'Context',
  'ms.maxOutput': 'Max output',
  'ms.input': 'Input',
  'ms.output': 'Output',
  'ms.webSearch': 'Web search',
  'ms.loading': 'Loading models…',
  'ms.loadingHint': 'Loading list prices from billing SSOT…',
  'ms.priceUnavailable': 'Pricing unavailable',
  'ms.priceUnavailableHint': 'Local catalog prices are hidden to avoid billing mistakes. Refresh later or check pricing SSOT.',
  'ms.empty': 'No matching models',
  'ms.emptyHint': 'Try fewer filters or a different keyword',
  'ms.resetFilters': 'Reset filters',
  'ms.viewAll': 'View all {n} official models ▾',
  'ms.collapse': 'Collapse ▴',
  'ms.allOfficial': 'All {title}',
  'ms.legacy': '📦 Classic · {n} models ({action})',
  'ms.legacyOpen': 'expand ▾',
  'ms.legacyClose': 'collapse ▴',
  'ms.cap.vision': 'Vision',
  'ms.cap.functions': 'Functions',
  'ms.cap.reasoning': 'Reasoning',
  'ms.cap.caching': 'Cache',
  'ms.cap.web': 'Search',
  'ms.cap.audio': 'Audio',
  'ms.cap.video': 'Video',
  'ms.cap.pdf': 'PDF',
  'ms.cap.chat': 'Chat',
  'ms.copyId': 'Click to copy model ID',
  'ms.openaiCompat': 'OpenAI compatible',
  'ms.anthropicNative': 'Anthropic Native',
  'ms.savePct': 'Save {n}%',
  'ms.cacheRead': 'Cache read',
  'ms.cacheWrite': 'Cache write',
  'ms.genImage': 'Image gen',
  'ms.genVideo': 'Video gen',
  'ms.genAudio': 'Audio',
  'ms.unitImage': 'img',
  'ms.unitAudio': '10k chars',
  'ms.unitVideo': 'sec'
};

const vi = {
  'menu.dashboard': 'Tổng quan',
  'menu.modelsquare': 'Quảng trường mô hình',
  'menu.playground': 'Trải nghiệm',
  'menu.token': 'API Key',
  'menu.billing': 'Hóa đơn &用量',
  'menu.team': 'Nhóm của tôi',
  'menu.profile': 'Của tôi',
  'menu.product-pricing': 'Giá & chi phí',
  'menu.supply': 'Cung ứng & định tuyến',
  'menu.customer': 'Khách hàng',
  'menu.customer-pricing': 'Giá khách hàng',
  'menu.user-spend': 'Chi tiêu người dùng',
  'menu.log': 'Lưu lượng & nhật ký',
  'menu.upstream-recon': 'Đối soát upstream',
  'menu.offlinetopup': 'Nạp ngoại tuyến',
  'menu.setting': 'Cài đặt',

  'common.all': 'Tất cả',
  'profile.center': 'Trang cá nhân',
  'profile.logout': 'Đăng xuất',
  'profile.account': 'Tài khoản',

  'greet.dawn': 'Chào đêm khuya',
  'greet.morning': 'Chào buổi sáng',
  'greet.noon': 'Chào buổi trưa',
  'greet.afternoon': 'Chào buổi chiều',
  'greet.evening': 'Chào buổi tối',
  'role.admin': 'Quản trị',
  'role.viewer': 'Chỉ xem',

  'dash.channelMgmt': 'Quản lý kênh',
  'dash.customerMgmt': 'Quản lý khách',
  'dash.platformSpend': 'Chi tiêu nền tảng',
  'dash.range7d': '7 ngày',
  'dash.range30d': '30 ngày',
  'dash.rangeCustom': 'Tùy chọn',
  'dash.trend7d': 'Xu hướng chi tiêu · 7 ngày',
  'dash.trend30d': 'Xu hướng chi tiêu · 30 ngày',
  'dash.trendCustom': 'Xu hướng chi tiêu · tùy chọn',
  'dash.todayByModel': 'Hôm nay theo mô hình',

  'ms.title': 'Quảng trường mô hình',
  'ms.subtitle': '{n} mô hình · một API Key dùng tất cả · giá hiển thị khớp trừ tiền',
  'ms.searchPh': 'Tìm tên / ID mô hình',
  'ms.provider': 'Nhà cung cấp',
  'ms.allProviders': 'Tất cả nhà cung cấp',
  'ms.source': 'Nguồn',
  'ms.official': 'Chính thức',
  'ms.pool': 'Pool',
  'ms.sort': 'Sắp xếp',
  'ms.sortRecommend': 'Đề xuất',
  'ms.sortPriceAsc': 'Giá: thấp → cao',
  'ms.sortPriceDesc': 'Giá: cao → thấp',
  'ms.sortCtxDesc': 'Context: lớn → nhỏ',
  'ms.typeAll': 'Tất cả',
  'ms.typeText': 'Văn bản',
  'ms.typeCoding': 'Coding',
  'ms.kind': 'Loại mô hình',
  'ms.allKinds': 'Tất cả loại',
  'ms.kind.chat': 'Chat',
  'ms.kind.coding': 'Coding',
  'ms.kind.reasoning': 'Lý luận',
  'ms.kind.embedding': 'Embedding',
  'ms.kind.rerank': 'Rerank',
  'ms.kind.image_gen': 'Tạo ảnh',
  'ms.kind.image_edit': 'Sửa ảnh',
  'ms.kind.video_gen': 'Tạo video',
  'ms.kind.tts': 'TTS',
  'ms.kind.asr': 'Nhận dạng giọng nói',
  'ms.modText': 'Mô hình văn bản',
  'ms.modTextSub': 'Chat · Coding · Lý luận',
  'ms.modImage': 'Mô hình ảnh',
  'ms.modImageSub': 'Text-to-image · Chỉnh sửa',
  'ms.modVideo': 'Mô hình video',
  'ms.modVideoSub': 'Text-to-video · tính theo giây',
  'ms.modAudio': 'Mô hình âm thanh',
  'ms.modAudioSub': 'TTS · Nhận dạng giọng nói',
  'ms.available': 'Khả dụng',
  'ms.context': 'Context',
  'ms.maxOutput': 'Đầu ra tối đa',
  'ms.input': 'Input',
  'ms.output': 'Output',
  'ms.webSearch': 'Tìm web',
  'ms.loading': 'Đang tải mô hình…',
  'ms.loadingHint': 'Đang tải giá từ SSOT…',
  'ms.priceUnavailable': 'Giá tạm thời không khả dụng',
  'ms.priceUnavailableHint': 'Ẩn giá cục bộ để tránh sai thanh toán. Hãy làm mới sau hoặc kiểm tra SSOT.',
  'ms.empty': 'Không có mô hình phù hợp',
  'ms.emptyHint': 'Thử bớt bộ lọc hoặc đổi từ khóa',
  'ms.resetFilters': 'Đặt lại bộ lọc',
  'ms.viewAll': 'Xem tất cả {n} mô hình chính thức ▾',
  'ms.collapse': 'Thu gọn ▴',
  'ms.allOfficial': 'Tất cả {title}',
  'ms.legacy': '📦 Cổ điển · {n} mô hình ({action})',
  'ms.legacyOpen': 'mở ▾',
  'ms.legacyClose': 'thu gọn ▴',
  'ms.cap.vision': 'Thị giác',
  'ms.cap.functions': 'Hàm',
  'ms.cap.reasoning': 'Lý luận',
  'ms.cap.caching': 'Cache',
  'ms.cap.web': 'Tìm kiếm',
  'ms.cap.audio': 'Âm thanh',
  'ms.cap.video': 'Video',
  'ms.cap.pdf': 'PDF',
  'ms.cap.chat': 'Chat',
  'ms.copyId': 'Nhấn để sao chép ID',
  'ms.openaiCompat': 'Tương thích OpenAI',
  'ms.anthropicNative': 'Anthropic Native',
  'ms.savePct': 'Tiết kiệm {n}%',
  'ms.cacheRead': 'Đọc cache',
  'ms.cacheWrite': 'Ghi cache',
  'ms.genImage': 'Tạo ảnh',
  'ms.genVideo': 'Tạo video',
  'ms.genAudio': 'Âm thanh',
  'ms.unitImage': 'ảnh',
  'ms.unitAudio': 'vạn ký tự',
  'ms.unitVideo': 'giây'
};

// fix accidental Chinese in Vietnamese billing menu
vi['menu.billing'] = 'Hóa đơn & sử dụng';

export const MESSAGES = { zh, en, vi };
export const SUPPORTED_LOCALES = ['zh', 'en', 'vi'];
